import React, { useState } from 'react';
import './login.css';
import { useNavigate } from 'react-router-dom';
import { API_URL as LOGIN_API_URL } from '../../../apis/apiLogin';  // Asegúrate de que la ruta es correcta

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Utiliza LOGIN_API_URL en lugar de la URL fija
        const response = await fetch(`${LOGIN_API_URL}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username: email, password }),
        });

        if (response.ok) {
            const data = await response.json();
            localStorage.setItem('token', data.access); // Guarda el token en localStorage
            navigate('/admin-tienda'); // Redirige a una página protegida
        } else {
            alert('Error de inicio de sesión');
        }
    };

    return (
        <div className="container">
            <form className="form" onSubmit={handleSubmit}>
                <h2 className="title">Inicio de Sesión</h2>
                <input
                    type="text"
                    placeholder="Correo"
                    className="input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <input
                    type="password"
                    placeholder="Contraseña"
                    className="input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button type="submit" className="button">Ingresar</button>
            </form>
        </div>
    );
}

export default Login;
